import { View } from "@/styles/reactnative";
import { ThemeContext } from "@/theme/ThemeProvider";
import { useIsMobile } from "@utils/CalVW.tsx";
import React, { useContext } from "react";
import styled from "styled-components";
import CModalHeader from "../Modal/CModalHeader";
import DepositLeftSection from "./DepositLeftSection";
import DepositRightSection from "./DepositRightSection";

const DepositModal = ({ setShowModal }) => {
  const { drawerBgColor } = useContext(ThemeContext).theme.COLORS;
  const {  isDarkMode, toggleTheme, } = useContext(ThemeContext);
  const theme = isDarkMode ? 'dark' : 'light';
  const isMobile = useIsMobile();

  return (
    <ModernDepositContainer isDarkMode={isDarkMode}>
      {/* <BackgroundGradient isDarkMode={isDarkMode} /> */}
      
      <ModalContent>
        <CModalHeader title={"deposit"} closeModal={() => setShowModal(false)} />
        
        <ContentWrapper isMobile={isMobile}>
          <MainSection>
            <DepositLeftSection />
          </MainSection>

          {!isMobile && (
            <SideSection>
              <DepositRightSection />
            </SideSection>
          )}
        </ContentWrapper>
      </ModalContent>
    </ModernDepositContainer>
  );
};

// Styled Components - WithdrawModal과 동일한 모던 디자인 적용
const ModernDepositContainer = styled.div<{ isDarkMode: boolean }>`
  width: 100%;
  height: 630px;
  position: relative;
  border-radius: 16px;
  overflow: hidden;
  background: ${props => props.isDarkMode 
    ? 'linear-gradient(135deg, #0A0A0A 0%, #1A1A1A 50%, #0F0F0F 100%)'
    : 'linear-gradient(135deg, #2C2C2C 0%, #1A1A1A 50%, #0F0F0F 100%)'
  };
  box-shadow: ${props => props.isDarkMode
    ? '0 20px 40px rgba(0, 0, 0, 0.8), 0 15px 30px rgba(0, 0, 0, 0.6)'
    : '0 20px 40px rgba(0, 0, 0, 0.7), 0 15px 30px rgba(0, 0, 0, 0.5)'
  };
  border: 1px solid ${props => props.isDarkMode 
    ? 'rgba(255, 255, 255, 0.1)' 
    : 'rgba(255, 255, 255, 0.15)'
  };
  transition: all 0.3s ease;
`;

const BackgroundGradient = styled.div<{ isDarkMode: boolean }>`
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  height: 150px;
  background: ${props => props.isDarkMode
    ? 'linear-gradient(135deg, #FF5C17 0%, #FF8A50 50%, #7E39FF 100%)'
    : 'linear-gradient(135deg, #FF5C17 0%, #FF8A50 50%, #FFB084 100%)'
  };
  opacity: ${props => props.isDarkMode ? '0.15' : '0.08'};
  z-index: 0;
`;

const ModalContent = styled.div`
  position: relative;
  z-index: 1;
  padding: 20px;
  height: 100%;
  display: flex;
  flex-direction: column;
 
`;

const ContentWrapper = styled.div<{ isMobile: boolean }>`
  flex: 1;
  display: flex;
  flex-direction: ${props => props.isMobile ? 'column' : 'row'};
  gap: 0px;
  margin-top: 5px;
  overflow-y: auto;
  
`;

const MainSection = styled.div`
  width: 100%;
`;

const SideSection = styled.div`
  width: auto;
  margin-top: 10px;
  padding-right: 10px;
`;

export default React.memo(DepositModal);
